import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemaSection } from './components/ProblemaSection';
import { ProductoSection } from './components/ProductoSection';
import { BeneficiosSection } from './components/BeneficiosSection';
import { ContenidoSection } from './components/ContenidoSection';
import { ParaQuienSection } from './components/ParaQuienSection';
import { BonosSection } from './components/BonosSection';
import { OfertaSection } from './components/OfertaSection';
import { FaqSection } from './components/FaqSection';
import { CierreSection } from './components/CierreSection';
import { SocialProofNotification } from './components/SocialProofNotification';
export function App() {
  return <div className="w-full min-h-screen bg-[#FFF9F5]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemaSection data-id="element-2" />
      <ProductoSection data-id="element-3" />
      <BeneficiosSection data-id="element-4" />
      <ContenidoSection data-id="element-5" />
      <ParaQuienSection data-id="element-6" />
      <BonosSection data-id="element-7" />
      <OfertaSection data-id="element-8" />
      <FaqSection data-id="element-9" />
      <CierreSection data-id="element-10" />
      <SocialProofNotification data-id="element-11" />
    </div>;
}